import { ButtonLink } from '@carouselgg/nexus/button'
import type { TrustScoreTip } from '@carouselgg/auth/types'
import { tipActionLabel, tipCategoryLine } from './trustCopy'
import styles from './TipList.module.css'

/**
 * Ways to raise a score, biggest gain first: what to do, which part of the
 * score it lands in, what it is worth, and a button to go and do it.
 */
export function TipList({ tips, label }: { tips: TrustScoreTip[]; label: string }) {
  return (
    <ol className={styles.list} aria-label={label}>
      {tips.map((tip, i) => (
        <li key={`${tip.category}-${tip.label}`} className={styles.row}>
          <span className={styles.index} aria-hidden="true">{i + 1}</span>
          <span className={styles.text}>
            <span className={styles.label}>{tip.label}</span>
            <span className={styles.meta}>{tipCategoryLine(tip)}</span>
          </span>
          <span className={styles.points}>+{tip.points}</span>
          {tip.action_url ? (
            <ButtonLink to={tip.action_url} variant={i === 0 ? 'primary' : 'secondary'} size="sm" className={styles.action}>
              {tipActionLabel(tip.action)}
            </ButtonLink>
          ) : <span />}
        </li>
      ))}
    </ol>
  )
}
